export function prettyTime(time) {
  const temp = time.split(':');
  return `${temp[0]}:${temp[1]}`;
}
